import { GrowthBook } from '@growthbook/growthbook'
import { UserDataType } from '../context/types'

export const growthbook = new GrowthBook({
  enableDevMode: true
})

export const loadGrowthBookFeatures = async (): Promise<void> => {
  const resolvedUrl = (process.env.NEXT_PUBLIC_GROWTHBOOK_API_URL_AU || '').trim()

  if (!resolvedUrl) {
    console.error('GrowthBook API URL not found')

    return
  }

  try {
    const response = await fetch(resolvedUrl)
    const { features, user } = await response.json()

    growthbook.setPayload({ features })

    if (user?.email) {
      await growthbook.updateAttributes({ email: user.email })
    }
  } catch (error) {
    console.error('Error loading GrowthBook features:', error)
  }
}

export const setGrowthBookAttributes = (attributes: Record<string, any> | UserDataType) => {
  growthbook.setAttributes(attributes)
}
